export const HEIGHT_HEADER_LANE = 160;
export const HEIGHT_HEADER_TITLE_LANE = 30;
export const WIDTH_CONNECTION_LANE = 50;
export const PROJECTION = 'EPSG:3857';
export const WIDTH_LANE = 300;